export default {
  WITH_DOWNLOAD_PROPOSAL_AS_PDF: import.meta.env.WITH_DOWNLOAD_PROPOSAL_AS_PDF === "true",
  HEROKU_SLUG_COMMIT: import.meta.env.HEROKU_SLUG_COMMIT,
};
